export default [
  {
    path: '/user/info/:id',
    name: 'UserDetail',
    component: () => import('@/views/Users/UserDetail.vue'),
    children: [
      {
        path: 'personal',
        name: 'UserDetail_personalTab',
        component: () => import('@/components/page/user/UserDetail_personalTab.vue')
      }
    ]
  }
]
